const { LoginResult, OTP_EXPIRY_IN_MINUTES, LoginError } = require('./constant');

function VerifyOtpController($state, loginService, moveFocus) {
    this.$onInit = function() {
        this.loginService = loginService;
        this.moveFocus = moveFocus;
        this.codeInput = '';
        this.loading = false;
        this.$state = $state;
        this.otpExpiry = OTP_EXPIRY_IN_MINUTES;
        this.isEmail = !!this.emailMasked;
        this.channel = this.isEmail ? 'email' : 'mobile';
        this.sentTo = this.isEmail ? 'to your email address ' + this.emailMasked : 'via SMS to your mobile number ' + this.phoneMasked;
        this.buttonText = !!this.phone ? 'Verify' : 'Continue';
        this.canGoBack = !!this.phone;
        this.showCodeSentMessage = false;

        // Move focus to input when view has loaded
        moveFocus('#verifyOtpForm-code');
    };
}

VerifyOtpController.prototype.sendVerifyRequest = function () {
    const self = this;
    this.verifyOtpForm.Code.$setValidity('server', true);

    if (!this.verifyOtpForm.$valid) {
        // don't submit to server if client side is not valid
        return;
    }
    this.loading = true;

    this.loginService.verifyOTP(this.email, this.password, this.codeInput, this.phone).then(
        function (response) {
            self.loading = false;
            if (response.LoginResult === LoginResult.SUCCESS) {
                if (response.ShouldUpdatePassword) {
                    self.$state.go('shop.secureaccount.form');
                } else {
                    self.loginService.redirectAfterLogin();
                }
            } else if (response.LoginResult === LoginResult.RESET_PASSWORD) {
                self.$state.go('shop.authentication.resetpassword', { passwordResetToken: response.PasswordResetToken });
            } else if (response.LoginResult === LoginResult.REQUIRE_PHONE_CAPTURE) {
                self.$state.go('shop.authentication.mobileNumberCapture', {
                    email: self.email,
                    password: self.password
                });
            } else if (response.LoginResult === LoginResult.INCORRECT_MFA_CODE
                    || response.LoginResult === LoginResult.NO_MFA_CODE
            ) {
                self.serverErrorMessage = response.AuthenticationErrorMessage;
                self.verifyOtpForm.Code.$setValidity('server', false);
            } else if (response.LoginResult === LoginResult.TOO_MANY_MFA_ATTEMPTS) {
                self.$state.go('shop.authentication.error', { error: LoginError.TOO_MANY_VERIFICATION_ATTEMPTS });
            } else {
                self.$state.go('shop.authentication.login');
            }
        }
    ).catch(function() {
        self.loading = false;
        self.$state.go('shop.authentication.error', { error: LoginError.VERIFICATION_SERVER_ERROR });
    });
};

VerifyOtpController.prototype.resendOTP = function () {
    const self = this;

    const showMessage = function () {
        self.showCodeSentMessage = true;
        setTimeout(() => {
            self.showCodeSentMessage = false;
        }, 3000);
    };

    this.loginService.sendOTP(this.email, this.password, this.phone).then(
        function (response) {
            if (response.LoginResult === LoginResult.REQUIRE_EMAIL_MFA) {
                showMessage();
            } else if (response.LoginResult === LoginResult.REQUIRE_SMS_MFA) {
                if (self.isEmail) {
                    self.$state.go('shop.authentication.verifyMobile', {
                        email: self.email,
                        password: self.password,
                        phoneMasked: response.MaskedPhone
                    });
                } else {
                    showMessage();
                }
            } else if (response.LoginResult === LoginResult.TOO_MANY_MFA_ATTEMPTS) {
                self.$state.go('shop.authentication.error', { error: 'TooManyCodeGenerationAttempts' });
            } else {
                self.$state.go('shop.authentication.login');
            }
        }
    ).catch(function() {
        // do nothing, customer to contact customer hub
    });
};


VerifyOtpController.prototype.goBack = function () {
    if (this.canGoBack) {
        this.$state.go('shop.authentication.mobileNumberCapture', {
            email: this.email,
            password: this.password
        });
    }
};

function verifyOtpDirectiveFactory() {
    return {
        restrict: 'E',
        scope: {
            email: '@',
            password: '@',
            phone: '@',
            phoneMasked: '@',
            emailMasked: '@'
        },
        controller: ['$state', 'LoginService', 'MoveFocus', VerifyOtpController],
        controllerAs: 'ctrl',
        bindToController: true,
        template: require('./login-verify-otp-template.html').trim()
    };
}

module.exports = {
    DirectiveController: VerifyOtpController,
    directiveFactory: verifyOtpDirectiveFactory
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/login/login-verify-otp-directive.js
 **/